import Swal from "sweetalert2";
import { cacheClinicDefaultTheme, clinicDefaultTheme } from "@/utils/theme";
export default {
  namespaced: true,
  state: {
    companyProfile: {},
    settings: {},
    deviceType: "desktop",
    companyLogo: "",
    isLoading: false,
    isLogoLoading: false,
    isSaving: false,
    customToolbar: [
      ["font", "bold", "italic", "underline", "strike"],
      [{ list: "ordered" }, { list: "bullet" }],
      [{ background: ["yellow", "red", "blue", "green", "purple", "brown"] }],
      ["clean"],
    ],
    publicSettings: {
      loading: false,
      data: {},
    },
    onlineBookingSettings: {
      loading: false,
      data: {},
    },
    hcaiSettings: {
      loading: false,
      data: {},
    },
    updateOnlineBookingSettingsLoading: false,
    groupSessionsSettings: {
      loading: false,
      data: {},
    },
    updateGroupSessionsSettingsLoading: false,
    notificationSettings: {
      loading: false,
      saving: false,
      data: null,
    },
    themeSettings: {
      loading: false,
      saving: false,
      loaded: false,
      data: { themes: [], default_theme_id: null },
    },
  },
  mutations: {
    SET_STATE: (state, obj) => {
      state[`${obj.key}`] = obj.value;
    },
    SET_PUBLIC_SETTINGS_LOADING: (state, value) => {
      state.publicSettings.loading = value;
    },
    SET_PUBLIC_SETTINGS_DATA: (state, value) => {
      state.publicSettings.data = value;
    },
    SET_ONLINE_BOOKING_SETTINGS_LOADING: (state, value) => {
      state.onlineBookingSettings.loading = value;
    },
    SET_ONLINE_BOOKING_SETTINGS_DATA: (state, value) => {
      state.onlineBookingSettings.data = value;
    },
    SET_UPDATE_ONLINE_BOOKING_SETTINGS_LOADING: (state, value) => {
      state.updateOnlineBookingSettingsLoading = value;
    },
    SET_GROUP_SESSIONS_SETTINGS_LOADING: (state, value) => {
      state.groupSessionsSettings.loading = value;
    },
    SET_GROUP_SESSIONS_SETTINGS_DATA: (state, value) => {
      state.groupSessionsSettings.data = value;
    },
    SET_UPDATE_GROUP_SESSIONS_SETTINGS_LOADING: (state, value) => {
      state.updateGroupSessionsSettingsLoading = value;
    },
    SET_DEVICE_TYPE: (state, value) => {
      state.deviceType = value;
    },
    SET_HCAI_SETTINGS_LOADING: (state, value) => {
      state.hcaiSettings.loading = value;
    },
    SET_HCAI_SETTINGS_DATA: (state, value) => {
      state.hcaiSettings.data = value;
    },
    SET_NOTIFICATION_SETTINGS_LOADING: (state, value) => {
      state.notificationSettings.loading = value;
    },
    SET_NOTIFICATION_SETTINGS_SAVING: (state, value) => {
      state.notificationSettings.saving = value;
    },
    SET_NOTIFICATION_SETTINGS_DATA: (state, value) => {
      state.notificationSettings.data = value;
    },
    SET_THEME_SETTINGS_LOADING: (state, value) => {
      state.themeSettings.loading = value;
    },
    SET_THEME_SETTINGS_SAVING: (state, value) => {
      state.themeSettings.saving = value;
    },
    SET_THEME_SETTINGS_DATA: (state, value) => {
      state.themeSettings.data = {
        themes: value?.themes || [],
        default_theme_id: value?.default_theme_id ?? null,
      };
      state.themeSettings.loaded = true;
    },
  },
  actions: {
    getSettings: function (context) {
      context.commit("SET_STATE", { key: "isLoading", value: true });
      let vm = this;
      return new Promise(function (resolve) {
        vm.$http
          .get("settings")
          .then((res) => {
            if (res.status == 200) {
              const settings = res.data;

              context.commit("SET_STATE", {
                key: "settings",
                value: settings,
              });
              context.commit("SET_STATE", { key: "isLoading", value: false });
              return resolve(settings);
            }
            context.commit("SET_STATE", { key: "isLoading", value: false });
            return resolve(false);
          })
          .catch((err) => {
            if (!err.accessDenied) {
              Swal.fire({
                title: "Error",
                text: (err.data || {}).message || "Something went wrong...",
                icon: "error",
              });
            }
            context.commit("SET_STATE", { key: "isLoading", value: false });
            return resolve(false);
          });
      });
    },
    getPublicSettings: function ({ commit }) {
      const vm = this;
      commit("SET_PUBLIC_SETTINGS_LOADING", true);
      return new Promise((resolve) => {
        return vm.$http.get(`settings/public`).then(
          (res) => {
            commit("SET_PUBLIC_SETTINGS_DATA", res.data);
            commit("SET_PUBLIC_SETTINGS_LOADING", false);
            resolve(res.data);
          },
          (err) => {
            commit("SET_PUBLIC_SETTINGS_LOADING", false);
            Swal.fire({
              title: "Error",
              text:
                err?.data?.error?.message ||
                err?.data?.message ||
                "Something went wrong...",
              icon: "error",
            });
            resolve(false);
          }
        );
      });
    },
    getCompanyProfile: function (context) {
      context.commit("SET_STATE", { key: "isLoading", value: true });
      let vm = this;
      return new Promise(function (resolve) {
        vm.$http
          .get("companies")
          .then((res) => {
            if (res.status == 200) {
              let companyProfileData = res.data.data;
              // TODO check with backend side if there is
              // another way instead of getting a list of profiles
              if (res.data.data.length > 0) {
                companyProfileData = res.data.data[0];
              }
              if (companyProfileData.logo) {
                companyProfileData.logo =
                  companyProfileData.logo.split("?response")[0];
              }

              context.commit("SET_STATE", {
                key: "companyProfile",
                value: companyProfileData,
              });

              context.commit("SET_STATE", {
                key: "companyLogo",
                value: companyProfileData.logo,
              });
              context.commit("SET_STATE", { key: "isLoading", value: false });
              return resolve(companyProfileData);
            }
            context.commit("SET_STATE", { key: "isLoading", value: false });
            return resolve(false);
          })
          .catch((err) => {
            if (!err.accessDenied) {
              Swal.fire({
                title: "Error",
                text: (err.data || {}).message || "Something went wrong...",
                icon: "error",
              });
            }
            context.commit("SET_STATE", { key: "isLoading", value: false });
            return resolve(false);
          });
      });
    },
    getCompanyProfileLogo: function (context) {
      context.commit("SET_STATE", { key: "isLogoLoading", value: true });
      let vm = this;
      return new Promise(function (resolve) {
        vm.$http
          .get("company-logo-name")
          .then((res) => {
            if (res.status == 200) {
              let companyProfileLogo = (
                ((res.data || {}).data || {}).logo || ""
              ).split("?response")[0];

              context.commit("SET_STATE", {
                key: "companyLogo",
                value: companyProfileLogo,
              });

              if (((res.data || {}).data || {}).logo) {
                res.data.data.logo = res.data.data.logo.split("?response")[0];
              }
              const valueToSave = {
                ...context.state.companyProfile,
                ...((res.data || {}).data || {}),
              };
              context.commit("SET_STATE", {
                key: "companyProfile",
                value: valueToSave,
              });
              context.commit("SET_STATE", {
                key: "isLogoLoading",
                value: false,
              });
              return resolve(valueToSave);
            }
            context.commit("SET_STATE", { key: "isLogoLoading", value: false });
            return resolve(false);
          })
          .catch((err) => {
            if (!err.accessDenied) {
              Swal.fire({
                title: "Error",
                text: (err.data || {}).message || "Something went wrong...",
                icon: "error",
              });
            }
            context.commit("SET_STATE", { key: "isLogoLoading", value: false });
            resolve(false);
          });
      });
    },
    updateSignaturePhoto: function (_, data) {
      let vm = this;
      let formData = new FormData();
      formData.append("signature", data.logo);
      return new Promise(function (resolve) {
        vm.$http
          .post(`companies/upload-signature/${data.id}`, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((res) => {
            resolve(res && res.data && res.data.signature);
          })
          .catch((err) => {
            if (!err.accessDenied) {
              Swal.fire({
                title: "Error",
                text: (err.data || {}).message || "Something went wrong...",
                icon: "error",
              });
            }
            resolve();
          });
      });
    },
    updateLogoPhoto: function (_, data) {
      let vm = this;
      let formData = new FormData();
      if (data.logo) {
        formData.append("logo", data.logo);
      }
      if (data.second_logo) {
        formData.append("second_logo", data.second_logo);
      }
      return new Promise(function (resolve) {
        vm.$http
          .post(`companies/upload/${data.id}`, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((res) => {
            if (data.logo) {
              return resolve(res && res.data && res.data.data.logo);
            }
            if (data.second_logo) {
              return resolve(res && res.data && res.data.data.second_logo);
            }
            return resolve();
          })
          .catch((err) => {
            if (!err.accessDenied) {
              Swal.fire({
                title: "Error",
                text: (err.data || {}).message || "Something went wrong...",
                icon: "error",
              });
            }
            resolve();
          });
      });
    },
    updateBotLogo: function (_, data) {
      let vm = this;
      let formData = new FormData();
      if (data.bot_logo) {
        formData.append("bot_logo", data.bot_logo);
      }
      return new Promise(function (resolve) {
        vm.$http
          .post(`companies/upload-bot-logo/${data.id}`, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((res) => {
            if (data.bot_logo) {
              return resolve(res && res.data && res.data.data.bot_logo);
            }
            return resolve();
          })
          .catch((err) => {
            if (!err.accessDenied) {
              Swal.fire({
                title: "Error",
                text: (err.data || {}).message || "Something went wrong...",
                icon: "error",
              });
            }
            resolve();
          });
      });
    },
    updateCompanyProfile: function (context, data) {
      let vm = this;
      context.commit("SET_STATE", { key: "isSaving", value: true });
      const headers = new Headers({
        "X-Requested-With": "XMLHttpRequest",
      });
      return new Promise(function (resolve) {
        vm.$http
          .put(
            "companies/" + data.id,
            data,
            data.fd,

            {
              headers: headers,
            }
          )
          .then((res) => {
            if (res) {
              context.commit("SET_STATE", { key: "isSaving", value: false });
              Swal.fire({
                title: "",
                text: "Company Profile Data Updated Successfully",
                icon: "success",
              });
              let companyProfileData = res.data.data;
              // TODO check with backend side if there is
              // another way instead of getting a list of profiles
              if (res.data.data.length > 0) {
                companyProfileData = res.data.data[0];
              }
              if (companyProfileData.logo) {
                companyProfileData.logo =
                  companyProfileData.logo.split("?response")[0];
              }

              context.commit("SET_STATE", {
                key: "companyProfile",
                value: companyProfileData,
              });

              context.commit("SET_STATE", {
                key: "companyLogo",
                value: companyProfileData.logo,
              });
              return resolve(res.data);
            }
            return resolve();
          })
          .catch((err) => {
            if (!err.accessDenied) {
              Swal.fire({
                title: "Error",
                text: (err.data || {}).message || "Something went wrong...",
                icon: "error",
              });
            }
            context.commit("SET_STATE", { key: "isSaving", value: false });
            return resolve();
          });
      });
    },

    ///Used only for the first time, if no company profile passed. TODO check with
    //backend if there is another way to upsert API instead of having 2
    createCompanyProfile: function (context, data = {}) {
      if (data.id == null) {
        context.commit("SET_STATE", { key: "isSaving", value: true });
        this.$http
          .post("companies", data)
          .then((res) => {
            if (res && res.data && res.data.data) {
              context.commit("SET_STATE", { key: "isSaving", value: false });
              Swal.fire({
                title: "",
                text: "Company Profile Data Updated Successfully",
                icon: "success",
              });
            } else {
              Swal.fire({
                title: "Error",
                text: (res.data || {}).message || "Something went wrong...",
                icon: "error",
              });
            }
          })
          .catch((err) => {
            if (!err.accessDenied) {
              Swal.fire({
                title: "Error",
                text: (err.data || {}).message || "Something went wrong...",
                icon: "error",
              });
            }
            context.commit("SET_STATE", { key: "isSaving", value: false });
          });
      }
    },
    getOnlineBookingSettings: function ({ commit }) {
      const vm = this;
      commit("SET_ONLINE_BOOKING_SETTINGS_LOADING", true);
      return new Promise((resolve) => {
        return vm.$http.get(`settings/online-booking`).then(
          (res) => {
            commit("SET_ONLINE_BOOKING_SETTINGS_DATA", res.data);
            commit("SET_ONLINE_BOOKING_SETTINGS_LOADING", false);
            resolve(res.data);
          },
          (err) => {
            commit("SET_ONLINE_BOOKING_SETTINGS_LOADING", false);
            if (!err.accessDenied) {
              Swal.fire({
                title: "Error",
                text:
                  err?.data?.error?.message ||
                  err?.data?.message ||
                  "Something went wrong...",
                icon: "error",
              });
            }
            resolve(false);
          }
        );
      });
    },
    updateOnlineBookingSettings: function ({ commit }, payload) {
      const vm = this;
      commit("SET_UPDATE_ONLINE_BOOKING_SETTINGS_LOADING", true);
      return new Promise((resolve) => {
        return vm.$http.put(`settings/online-booking`, payload).then(
          (res) => {
            commit("SET_UPDATE_ONLINE_BOOKING_SETTINGS_LOADING", false);
            Swal.fire({
              title: "Booking Settings Updated",
              text: "Booking settings have been updated successfully",
              icon: "success",
            }).then(() => {
              window.location.reload();
            });
            resolve(res.data);
          },
          (err) => {
            commit("SET_UPDATE_ONLINE_BOOKING_SETTINGS_LOADING", false);
            if (!err.accessDenied) {
              Swal.fire({
                title: "Error",
                text:
                  err?.data?.error?.message ||
                  err?.data?.message ||
                  "Something went wrong...",
                icon: "error",
              });
            }
            resolve(false);
          }
        );
      });
    },
    getGroupSessionsSettings: function ({ commit }) {
      const vm = this;
      commit("SET_GROUP_SESSIONS_SETTINGS_LOADING", true);
      return new Promise((resolve) => {
        return vm.$http.get(`settings/group-sessions`).then(
          (res) => {
            commit("SET_GROUP_SESSIONS_SETTINGS_DATA", res.data);
            commit("SET_GROUP_SESSIONS_SETTINGS_LOADING", false);
            resolve(res.data);
          },
          (err) => {
            commit("SET_GROUP_SESSIONS_SETTINGS_LOADING", false);
            if (!err.accessDenied) {
              Swal.fire({
                title: "Error",
                text:
                  err?.data?.error?.message ||
                  err?.data?.message ||
                  "Something went wrong...",
                icon: "error",
              });
            }
            resolve(false);
          }
        );
      });
    },
    updateGroupSessionsSettings: function ({ commit }, payload) {
      const vm = this;
      commit("SET_UPDATE_GROUP_SESSIONS_SETTINGS_LOADING", true);
      return new Promise((resolve) => {
        return vm.$http.put(`settings/group-sessions`, payload).then(
          (res) => {
            commit("SET_UPDATE_GROUP_SESSIONS_SETTINGS_LOADING", false);
            Swal.fire({
              title: "Group Sessions Settings Updated",
              text: "Group sessions settings have been updated successfully",
              icon: "success",
            }).then(() => {
              window.location.reload();
            });
            resolve(res.data);
          },
          (err) => {
            commit("SET_UPDATE_GROUP_SESSIONS_SETTINGS_LOADING", false);
            if (!err.accessDenied) {
              Swal.fire({
                title: "Error",
                text:
                  err?.data?.error?.message ||
                  err?.data?.message ||
                  "Something went wrong...",
                icon: "error",
              });
            }
            resolve(false);
          }
        );
      });
    },
    getDeviceType: function ({ commit }) {
      let deviceType = "desktop";
      if (window.innerWidth <= 767) {
        deviceType = "mobile";
      } else if (window.innerWidth <= 992) {
        deviceType = "tablet";
      }
      commit("SET_DEVICE_TYPE", deviceType);
    },
    getHcaiSettings: function ({ commit }) {
      const vm = this;
      commit("SET_HCAI_SETTINGS_LOADING", true);
      return new Promise((resolve) => {
        return vm.$http.get(`settings/hcai`).then(
          (res) => {
            commit("SET_HCAI_SETTINGS_DATA", res.data);
            commit("SET_HCAI_SETTINGS_LOADING", false);
            resolve(res.data);
          },
          (err) => {
            commit("SET_HCAI_SETTINGS_LOADING", false);
            if (!err.accessDenied) {
              Swal.fire({
                title: "Error",
                text:
                  err?.data?.error?.message ||
                  err?.data?.message ||
                  "Something went wrong...",
                icon: "error",
              });
            }
            resolve(false);
          }
        );
      });
    },
    updateHcaiSettings: function ({ commit }, payload) {
      const vm = this;
      return new Promise((resolve) => {
        return vm.$http.put(`settings/hcai`, payload).then(
          (res) => {
            Swal.fire({
              title: "HCAI Settings Updated",
              text: "HCAI settings have been updated successfully",
              icon: "success",
            }).then(() => {
              window.location.reload();
            });
            commit("SET_HCAI_SETTINGS_DATA", res.data);
            resolve(res.data);
          },
          (err) => {
            if (!err.accessDenied) {
              Swal.fire({
                title: "Error",
                text:
                  err?.data?.error?.message ||
                  err?.data?.message ||
                  "Something went wrong...",
                icon: "error",
              });
            }
            resolve(false);
          }
        );
      });
    },
    getNotificationSettings: function ({ commit }) {
      const vm = this;
      commit("SET_NOTIFICATION_SETTINGS_LOADING", true);
      return new Promise((resolve) => {
        return vm.$http.get("settings/notifications").then(
          (res) => {
            commit("SET_NOTIFICATION_SETTINGS_DATA", res.data.data);
            commit("SET_NOTIFICATION_SETTINGS_LOADING", false);
            resolve(res.data.data);
          },
          (err) => {
            commit("SET_NOTIFICATION_SETTINGS_LOADING", false);
            if (!err.accessDenied) {
              Swal.fire({
                title: "Error",
                text:
                  err?.data?.error?.message ||
                  err?.data?.message ||
                  "Something went wrong...",
                icon: "error",
              });
            }
            resolve(false);
          }
        );
      });
    },
    updateNotificationSettings: function ({ commit }, payload) {
      const vm = this;
      commit("SET_NOTIFICATION_SETTINGS_SAVING", true);
      return new Promise((resolve) => {
        return vm.$http.put("settings/notifications", payload).then(
          (res) => {
            commit("SET_NOTIFICATION_SETTINGS_DATA", res.data.data);
            commit("SET_NOTIFICATION_SETTINGS_SAVING", false);
            Swal.fire({
              title: "Notification Settings Updated",
              text: "Notification settings have been saved successfully.",
              icon: "success",
            });
            resolve(res.data.data);
          },
          (err) => {
            commit("SET_NOTIFICATION_SETTINGS_SAVING", false);
            if (!err.accessDenied) {
              Swal.fire({
                title: "Error",
                text:
                  err?.data?.error?.message ||
                  err?.data?.message ||
                  "Something went wrong...",
                icon: "error",
              });
            }
            resolve(false);
          }
        );
      });
    },
    // Silent on failure: every role calls this, and the theme modal must still open.
    getThemeSettings: function ({ commit, state }, { force = false } = {}) {
      const vm = this;
      if (state.themeSettings.loaded && !force) {
        return Promise.resolve(state.themeSettings.data);
      }
      commit("SET_THEME_SETTINGS_LOADING", true);
      return new Promise((resolve) => {
        return vm.$http.get("settings/themes").then(
          (res) => {
            commit("SET_THEME_SETTINGS_DATA", res.data.data);
            cacheClinicDefaultTheme(clinicDefaultTheme(res.data.data));
            commit("SET_THEME_SETTINGS_LOADING", false);
            resolve(res.data.data);
          },
          (err) => {
            commit("SET_THEME_SETTINGS_LOADING", false);
            //eslint-disable-next-line
            console.warn("Failed to load clinic themes:", err);
            resolve(false);
          }
        );
      });
    },
    addTheme: function ({ commit, state }, { silent = false, ...payload }) {
      const vm = this;
      commit("SET_THEME_SETTINGS_SAVING", true);
      return new Promise((resolve, reject) => {
        return vm.$http.post("settings/themes", payload).then(
          (res) => {
            const theme = res.data.data;
            commit("SET_THEME_SETTINGS_DATA", {
              ...state.themeSettings.data,
              themes: [...state.themeSettings.data.themes, theme],
            });
            commit("SET_THEME_SETTINGS_SAVING", false);
            resolve(theme);
          },
          (err) => {
            commit("SET_THEME_SETTINGS_SAVING", false);
            if (silent) {
              reject(err);
              return;
            }
            if (!err.accessDenied) {
              Swal.fire({
                title: "Error",
                text:
                  err?.data?.error?.message ||
                  err?.data?.message ||
                  "Something went wrong...",
                icon: "error",
              });
            }
            resolve(false);
          }
        );
      });
    },
    updateTheme: function ({ commit, state }, { id, name, themeColor }) {
      const vm = this;
      commit("SET_THEME_SETTINGS_SAVING", true);
      return new Promise((resolve) => {
        return vm.$http.put(`settings/themes/${id}`, { name, themeColor }).then(
          (res) => {
            const theme = res.data.data;
            commit("SET_THEME_SETTINGS_DATA", {
              ...state.themeSettings.data,
              themes: state.themeSettings.data.themes.map((existing) =>
                existing.id === theme.id ? theme : existing
              ),
            });
            commit("SET_THEME_SETTINGS_SAVING", false);
            resolve(theme);
          },
          (err) => {
            commit("SET_THEME_SETTINGS_SAVING", false);
            if (!err.accessDenied) {
              Swal.fire({
                title: "Error",
                text:
                  err?.data?.error?.message ||
                  err?.data?.message ||
                  "Something went wrong...",
                icon: "error",
              });
            }
            resolve(false);
          }
        );
      });
    },
    deleteTheme: function ({ commit }, id) {
      const vm = this;
      commit("SET_THEME_SETTINGS_SAVING", true);
      return new Promise((resolve) => {
        return vm.$http.delete(`settings/themes/${id}`).then(
          (res) => {
            commit("SET_THEME_SETTINGS_DATA", res.data.data);
            cacheClinicDefaultTheme(clinicDefaultTheme(res.data.data));
            commit("SET_THEME_SETTINGS_SAVING", false);
            resolve(res.data.data);
          },
          (err) => {
            commit("SET_THEME_SETTINGS_SAVING", false);
            if (!err.accessDenied) {
              Swal.fire({
                title: "Error",
                text:
                  err?.data?.error?.message ||
                  err?.data?.message ||
                  "Something went wrong...",
                icon: "error",
              });
            }
            resolve(false);
          }
        );
      });
    },
    setDefaultTheme: function ({ commit }, themeId) {
      const vm = this;
      commit("SET_THEME_SETTINGS_SAVING", true);
      return new Promise((resolve) => {
        return vm.$http
          .put("settings/themes/default", { default_theme_id: themeId })
          .then(
            (res) => {
              commit("SET_THEME_SETTINGS_DATA", res.data.data);
              cacheClinicDefaultTheme(clinicDefaultTheme(res.data.data));
              commit("SET_THEME_SETTINGS_SAVING", false);
              resolve(res.data.data);
            },
            (err) => {
              commit("SET_THEME_SETTINGS_SAVING", false);
              if (!err.accessDenied) {
                Swal.fire({
                  title: "Error",
                  text:
                    err?.data?.error?.message ||
                    err?.data?.message ||
                    "Something went wrong...",
                  icon: "error",
                });
              }
              resolve(false);
            }
          );
      });
    },
  },
};
